module.exports = __webpack_public_path__ + "img/shenhezhong@3x.56aa9e5f.svg";